module.exports = __webpack_public_path__ + "footbanner1.png?43a164902afe13073abb9f30e70ccb63";